import { Injectable, Type } from '@angular/core';
import { BaseApiService } from '@kinet-open-network/client/core/api-client';
import { DiscountCode } from '../models/discount-code.model';

@Injectable({
  providedIn: 'root',
})
export class DiscountCodesService extends BaseApiService<DiscountCode> {
  override model: Type<DiscountCode> = DiscountCode;

  override get endpoint(): string {
    return '/discount-codes';
  }
}
